import { createRootRouteWithContext } from '@tanstack/react-router';

import { RootLayout } from '@/app/root-layout';
import type { RouterContext } from '@/app/router-context';
import { NotFound } from '@/app/route-states';

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
  notFoundComponent: NotFound,
});
